import axios from "axios";

let categories = null;
let categoryRequest = null;

export function loadCategories() {
  if (categories) return Promise.resolve(categories);
  if (categoryRequest) return categoryRequest;

  categoryRequest = axios
    .get("/api/getcategory")
    .then((res) => {
      categories = res.data && res.data.status === 200 ? res.data.category || [] : [];
      return categories;
    })
    .catch(() => categories || [])
    .finally(() => {
      categoryRequest = null;
    });

  return categoryRequest;
}
